"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRAPPER_DEFAULT = exports.SPINNER_DEFAULTS = exports.SIZE = exports.IMAGE_URL = exports.IMAGE_NOT_FOUND = exports.IMAGE = exports.COLOR = exports.BTN_DEFAULTS = exports.ALIGN = void 0;
var SIZE = {
  medium: 'medium',
  default: 'default',
  titleNormal: 'titleNormal',
  textSmall: 'textSmall',
  small: 'small'
};
exports.SIZE = SIZE;
var COLOR = {
  green: 'green',
  greenLight: 'greenLight',
  greyDark: 'greyDark',
  greyDarker: 'greyDarker',
  tertiary: 'tertiary',
  neutral: 'neutral'
};
exports.COLOR = COLOR;
var IMAGE_NOT_FOUND = 'NO Image Fount';
exports.IMAGE_NOT_FOUND = IMAGE_NOT_FOUND;
var ALIGN = {
  center: 'center'
};
exports.ALIGN = ALIGN;
var IMAGE_URL = 'https://static.airasia.com/design/images/flight/No_wheelchair_available.svg';
exports.IMAGE_URL = IMAGE_URL;
var IMAGE = {
  width: '520px',
  height: '280px'
};
exports.IMAGE = IMAGE;
var BTN_DEFAULTS = {
  WIDTH: '128px',
  MOBILE_WIDTH: '230px',
  PADDING_LEFT: '24px',
  PADDING_RIGHT: '24px'
};
exports.BTN_DEFAULTS = BTN_DEFAULTS;
var SPINNER_DEFAULTS = {
  WIDTH: '20px',
  HEIGHT: '20px',
  STROKE_WIDTH: '4'
};
exports.SPINNER_DEFAULTS = SPINNER_DEFAULTS;
var WRAPPER_DEFAULT = {
  desktop: {
    width: '392px'
  },
  mobile: {
    width: '280px'
  }
};
exports.WRAPPER_DEFAULT = WRAPPER_DEFAULT;